<div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="bigtest">
        <div class="job-number">{{jobNumber}}</div>
        <!-- <app-customer-balance class="balance-position" style="margin-top: 0px;"></app-customer-balance> -->
    </div>
    <!-- <div class="btn-pos" fxLayout="row" fxLayoutAlign="start">
        <div style="margin-right: 20px;"><button mat-button class="button-green">Job History</button></div>
    </div> -->
</div>
